import KyError from 'components/Errors/KyError';
import Loading from 'components/Loading';
import FullWidthTemplate from 'components/Templates/FullWidth';
import {useGet} from 'helpers/KyHooks';
import CompanyTechStackList from 'pages/public/companyTechStack/List';


export default function CompanyTechStackPage() {
    
  const {response, error} = useGet('api/v1/companies/list');
    
  let body = <Loading />;
  if (response) {
    body = <CompanyTechStackList data={response.data.companies} />;
  } else if (error) {
    body = <KyError kyError={error} />;
  }
    
  return (
    <FullWidthTemplate title="Company Tech Stack Page">
      {body}
    </FullWidthTemplate>
  );
}
